import { FlexCol } from "@design-system/Layout/Flex";
import { cn } from "@design-system/Utilities";
import { useAtomValue } from "jotai";
import { type FC, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { isAiProgressPopupOpenAtom } from "./ctx";
import { useGeneratingQuestionnaireIds, useQuestions } from "./data";
import { Header } from "./Header";
import { Progress } from "./Progress";
import { Question } from "./Question";

export const AiProgressPopup: FC = () => {
    const isOpen = useAtomValue(isAiProgressPopupOpenAtom);
    const [isCollapsed, setIsCollapsed] = useState(false);

    const { generatingQuestionnaireIds } = useGeneratingQuestionnaireIds();
    const { questions } = useQuestions(generatingQuestionnaireIds);

    const isGenerating = useMemo(() => {
        return questions?.some(
            (question) => question.answer?.aiSuggestion?.isGenerating,
        );
    }, [questions]);

    if (!isOpen) return null;

    return createPortal(
        <FlexCol className="bg-gradient-to-r from-[#C238CC] to-[#B554F2] rounded-t-xxl p-[1px] w-[420px] fixed bottom-0 right-[90px]">
            <FlexCol className="bg-white rounded-t-xxl" h="full">
                <Header
                    questionCount={questions.length}
                    isGenerating={isGenerating}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setIsCollapsed}
                />
                <FlexCol
                    className={cn(
                        "transition-max-height duration-300 overflow-hidden",
                        isCollapsed ? "max-h-[0px]" : "max-h-[289px]",
                    )}
                >
                    <Progress questions={questions} />
                    <FlexCol
                        p="4"
                        gap="4"
                        className="overflow-y-auto max-h-[216px]"
                    >
                        {questions.map((question) => (
                            <Question key={question.id} question={question} />
                        ))}
                    </FlexCol>
                </FlexCol>
            </FlexCol>
        </FlexCol>,
        document.body,
    );
};
